import { UserInfoState } from '@core/user-info/store/states/user-info.state';

export const userInfoState = [UserInfoState];
